module.exports = __webpack_public_path__ + "img/top2.d9651aea.png";